// import MuiModel from "../../../components/Mui/model/MuiModel";

import { useEffect, useState } from "react";

import { useModal } from "../../hooks/useModal";
import { useData } from "../../context/GetDataContext";
import LoadSideBarSkeleton from "./LoadSideBarSkeleton";
import { useQuery } from "@apollo/client";
// import { LOAD_QUERY } from "./queries";
import Stop from "./components/stop";

import LoadDispatch from "./components/loadDispatch";
import LoadPickAndDelivery from "./components/loadPickAndDelivery";
import LoadHasDispatch from "./components/loadHasDispatch";
import { useUpdateForm } from "../../context/UpdateFormContext";

import FormBuildTabs from "../../plugins/formBuilder/FormBuildTabs";
import { useAxios } from "../../utils/useAxios";
import FormLoading from "../../Loaders/formLoading";
import MuiModelBox from "../Mui/model/MuiModelBox";
import styled from "styled-components";
import MuiModel from "../Mui/model/MuiModel";
import React from "react";
import { TailwindAccordion } from "../Tailwind/TailwindAccordion";
interface props {
  source?: any;
  getformData: any;
}

const LoadSideBarform = ({ source, getformData }: props) => {
  const { isOpen, openModal, closeModal } = useModal();
  // const {
  //   loading,
  //   error,
  //   data: apolloData,
  // } = useQuery(LOAD_QUERY, {
  //   variables: { id: 1032 },
  //   fetchPolicy: "cache-first",
  // });

  const [popData, setPopData] = useState<any>({});
  const { myData } = useUpdateForm();
  const [changeSplite, setChangeSplite] = useState(false);
  const [crudOp, setCrudOP] = useState({});
  const [resData, setResData] = useState({});
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const { res, mutate, isPending } = useAxios({
    url: "/api/auth/form",
  });

  const openlist = () => {
    setChangeSplite(false);
  };

  const { data } = useData();

  useEffect(() => {
    if (!myData) {
      return;
    }
    mutate({ formId: myData?.formId });
    openModal();
    setPopData(myData);
  }, [myData]);

  useEffect(() => {
    if (res) {
      let sections;
      if (popData?.sectionId) {
        sections = res?.data?.data?.sections?.filter(
          (id: any) => id?.sectionid === popData?.sectionId,
        );
        setCrudOP({
          id: data?.id,
          action: popData?.action,
        });
        setResData({
          formid: popData?.formId,
          sections: sections,
        });
      } else if (popData?.action === "create") {
        setResData(res?.data?.data);
      } else {
        setCrudOP({
          id: popData?.id ? popData?.id : data?.id,
          action: "edit",
        });
        setResData(res?.data?.data);
      }
    }
  }, [res]);

  // if (loading) return <div>Loading...</div>;
  // if (error) return <div>Error: {error.message}</div>;

  useEffect(() => {
    if (data?.LoadDispatch?.length > 0) {
      setOpenIndex(data.LoadDispatch.length - 1); // last index
    }
  }, [data?.LoadDispatch]);

  if (!data?.id) {
    return <LoadSideBarSkeleton />;
  }

  return (
    <>
      <div className="border mt-2.5">
        <div className="bg-white rounded-lg p-3">
          <h1 className="text-lg font-bold mb-4">Shipper/Consignee</h1>
          <h2 className="text-md font-semibold">Stops Info</h2>

          <h3 className="text-md font-semibold mt-4 bg-gray-200 p-2">
            Dispatch Info
          </h3>
          {data?.LoadDispatch?.length > 0 ? (
            data?.LoadDispatch.map((items: any, index: number) => {
              return (
                <TailwindAccordion
                  key={index}
                  title={<LoadDispatch source={source} dispatch={items} />}
                  isOpen={openIndex === index}
                  onToggle={() =>
                    setOpenIndex(openIndex === index ? null : index)
                  }
                >
                  <Stop source={source} />
                  <LoadHasDispatch />
                  <LoadPickAndDelivery />
                </TailwindAccordion>
              );
            })
          ) : (
            <React.Fragment>
              <LoadDispatch source={source} />
              <Stop source={source} />
              <LoadHasDispatch />
              <LoadPickAndDelivery />
            </React.Fragment>
          )}
        </div>
      </div>

      {isOpen && (
        <MuiModelBox
          isOpen={isOpen}
          onClose={closeModal}
          title={popData?.title}
        >
          <Div>
            {isPending ? (
              <FormLoading />
            ) : (
              // <></>
              <FormBuildTabs
                getformData={resData}
                openlist={openlist}
                crudOp={crudOp}
                source={source}
              />
            )}
          </Div>
        </MuiModelBox>
      )}
    </>
  );
};

export default LoadSideBarform;

const Div = styled("div")`
  .inpop {
    width: 100% !important;
  }
`;
